
import { Vue, Component } from 'vue-property-decorator';
import { DatabaseRepositoryInterface, MigrationBatchInterface } from '@/services/Database/interfaces';
import { DataTableHeader } from 'vuetify';
import WebsiteRepositoryInterface from '@/services/Website/interfaces';
import { ServerRepositoryInterface } from '@/services/Server/Interfaces';
import PageHeader from '@/components/layout/PageHeader.vue';
import StatusChip from '@/components/layout/StatusChip.vue';

@Component({
  components: {
    PageHeader,
    StatusChip,
  },
  inject: [
    'databaseRepository',
    'serverRepository',
    'websiteRepository',
  ],
})
export default class DatabasesMigrationsList extends Vue {
  public loading = true;

  public databaseRepository!: DatabaseRepositoryInterface;

  public serverRepository!: ServerRepositoryInterface;

  public websiteRepository!: WebsiteRepositoryInterface;

  public batches: MigrationBatchInterface[] = [];

  public batchHeaders: DataTableHeader[] = [
    { text: 'ID', value: 'id', width: '80px' },
    { text: 'Source', value: 'sourceWebsiteId' },
    { text: 'Source Server', value: 'sourceServer' },
    { text: 'Target', value: 'targetWebsiteId' },
    { text: 'Target Server', value: 'targetServer' },
    { text: 'Status', value: 'status' },
    { text: 'Created', value: 'createdAt' },
    { text: '', value: 'actions', sortable: false, width: '48px' },
  ];

  public websiteDomainsMap: { [key: number]: string } = {};

  public serverHostnamesMap: { [key: string]: string } = {};

  public async created(): Promise<void> {
    await this.loadBatches();
    await this.loadMaps();
    this.loading = false;
  }

  public async loadBatches(): Promise<void> {
    this.batches = await this.databaseRepository.getAllMigrationBatches();
  }

  public async loadMaps(): Promise<void> {
    const serverIds: string[] = [];
    const websiteIds: number[] = [];

    this.batches.forEach((batch) => {
      if (!serverIds.includes(batch.sourceServer)) {
        serverIds.push(batch.sourceServer);
      }

      if (!serverIds.includes(batch.targetServer)) {
        serverIds.push(batch.targetServer);
      }

      if (!websiteIds.includes(batch.sourceWebsiteId)) {
        websiteIds.push(batch.sourceWebsiteId);
      }

      if (!websiteIds.includes(batch.targetWebsiteId)) {
        websiteIds.push(batch.targetWebsiteId);
      }
    });

    const servers = await this.serverRepository.getServersByIds(serverIds);

    servers.forEach((server) => {
      this.serverHostnamesMap[server._id] = server.hostname;
    });

    const websites = await this.websiteRepository.getWebsitesByIds(websiteIds);

    websites.forEach((website) => {
      this.websiteDomainsMap[website.id] = website.domain;
    });
  }
}
